import { getStandardRetryDelay, getStandardRetryLogic } from "#lib/errors"
import { queryKeys } from "#lib/query-keys"
import { homeFinancialSDK } from "#sdk/sdk"
import type { UpdateTourStatus } from "@home-finance-manager/shared/types/tour"
import type { User } from "@home-finance-manager/shared/types/users"
import { useMutation, useQueryClient } from "@tanstack/react-query"

export function useUpdateTourStatus() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: UpdateTourStatus) => {
      const token = localStorage.getItem("auth_token")
      if (!token) {
        throw new Error("Authentication token not found. Please log in again.")
      }
      const response = await homeFinancialSDK.users.updateTourStatus(data)
      return response.data
    },
    onSuccess: (data) => {
      let currentUser = queryClient.getQueryData<User | null>(queryKeys.auth.user())

      if (!currentUser) {
        try {
          const storedUser = localStorage.getItem("user_data")
          if (storedUser) {
            currentUser = JSON.parse(storedUser) as User
          }
        } catch (error) {
          console.error("Failed to get user from localStorage:", error)
        }
      }

      if (currentUser) {
        const updatedUser: User = {
          ...currentUser,
          tourStartedAt: data.tourStartedAt,
          tourCompletedAt: data.tourCompletedAt,
          tourStepIndex: data.tourStepIndex,
        }
        localStorage.setItem("user_data", JSON.stringify(updatedUser))
        queryClient.setQueryData(queryKeys.auth.user(), updatedUser)
      }
    },
    retry: getStandardRetryLogic(),
    retryDelay: getStandardRetryDelay(),
  })
}
